import "react"

import useKiosk from 'effects/useKiosk'
import useKeyPress from 'effects/useKeyPress'


const KioskLayout = ({ children }) => {
  const { hideKiosk } = useKiosk()

  // we're only rendered if kiosk mode is active, we attach hotkeys now
  useKeyPress('Escape', hideKiosk)

  return (
    <div className="kiosk-wrapper">
      { children }
    </div>
  )
}

export default KioskLayout
